module.exports = require('./helpers/bundle-url').getBundleURL('iLkEm') + "logo.c51670a8.svg";